<div class="wrapper" [ngStyle]="wrapperStyles">
  <div class="parent">
    <div class="rect">
      <div class="content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
